import loadable from '@loadable/component'

export const MoreSection = loadable(() => import('./MoreSection'), {
  resolveComponent: (module) => module.MoreSection
})

export type { MoreSectionProps } from './MoreSection'
